// extracted by mini-css-extract-plugin
module.exports = {"SideNavigation":"SideNavigation-module--SideNavigation--w_7Ru","ActiveLink":"SideNavigation-module--ActiveLink--22miN"};